<script lang="ts">
	//UI
	//Utils
	//Types
	//Props
	//Constants
	//Variables
	//Functions
	//Do

</script>

<div class="container">
	<div class="header">
		<slot name="header" />
	</div>
	<div class="body">
		<slot />
	</div>
</div>

<style lang="scss">
	:global(body) {
		background-color: #f0f0f4;
	}
	.container {
		width: 100%;
		display: flex;
		flex-direction: column;
		margin-bottom: 25px;
		.header {
			display: flex;
			box-sizing: border-box;
			height: 45px;
			padding: 0px 20px;
			background-color: #6591fa;
		}
	}

</style>
